<template>
  <span>{{titleObj.title}}</span>&nbsp;<span v-if="is_home" class="css_styleColor4">{{titleObj.description}}</span>
</template>

<script>
import {useRubricArticleStore} from "@/stores/store";
import {computed, ref} from "vue";
import {storeToRefs} from "pinia";
import {
    CONST_ARTICLE_PATH,
    CONST_FILTERED_ARTICLES_PATH,
    CONST_HOME_PATH,
    CONST_RUBRIC_PATH
} from "../constants/consts";
import {useRoute} from "vue-router";
import {LS} from "../services/translate";

export default {
    setup(){
        const route = useRoute();

        const rubricArticleStore = useRubricArticleStore();
        const { nav_rubric_name, nav_article_name } = storeToRefs(rubricArticleStore);

        const is_home = ref(route.path === CONST_HOME_PATH);

        const titleObj = computed(() => {
          let title = '';
          let description = '';

          if(route.path === CONST_HOME_PATH) {
            title = LS("Поиск по")
            description = LS("Базе знаний")
          }
          else if(route.path === CONST_RUBRIC_PATH) {
            title = nav_rubric_name.value
          }
          else if (route.path === CONST_ARTICLE_PATH) {
            title = nav_article_name.value
          }
          else if (route.path === CONST_FILTERED_ARTICLES_PATH) {
            title = LS("Результат поиска")
          }

          return {
            'title': title,
            'description': description,
          }
        })

        return {
          is_home,
          titleObj
        }
    },
}
</script>

<style scoped>

</style>